export function getCatalogMessage(catalogName: string) {
    return `Error consultando cat\u00E1logo "${catalogName}"`;
}

export function getRequiredMessage(field: string): string {
    return `El campo "${field}" es requerido.`;
}

export function getMaxLengthMessage(field: string, length: number): string {
    return `El campo ${field} debe tener m\u00E1ximo ${length} caracteres.`;
}

export function getLengthMessage(field: string, length: number): string {
    return `El campo "${field}" debe tener ${length} caracteres.`;
}

export function getMinLengthMessage(field: string, length: number): string {
    return `El campo "${field}" debe tener al menos ${length} caracteres.`;
}

export function getValidationError(field: string): string {
    return `No es posible validar el campo "${field}"`;
}

export function getRangeLengthMessage(field: string, min: number, max: number): string {
    return `El campo "${field}" debe tener entre ${min} y ${max} caracteres.`;
}

export function getRegexMessage(field: string, format = ''): string {
    const message = `El campo "${field}" no cumple con el formato requerido. `;
    if (format) {
        return `${message} Formato requerido ${format}.`;
    }
    return message;
}

export function getUppercaseMessage(field: string) {
    return `El campo "${field}" no debe contener letras min\u00FAsculas.`;
}

export function getAnalyticsMessage(type: string, value: string): string {
    return `${type}: ${value}`;
}

export function deleteConfirmation(type: string, name: string): string {
    return `¿Desea eliminar el registro del ${type}: ${name}?`;
}

export function getMinValueMessage(field: string, value: number): string {
    return `El valor m\u00EDnimo para el campo ${field} es: ${value}`;
}

export function getMismatchMessage(): string {
    return 'El valor ingresado es incorrecto';
}

export function getConsigneeValidationError(name: string): string {
    return `Los datos de ${name} a\u00FAn no se encuentran disponibles para ser utilizados.`;
}
